import { Button } from 'react-bootstrap';
import { useCheckPreviousRegistration } from '../apiEndpoints/commApiEndpoints';
import { useNavigate } from 'react-router-dom';

const ResendOTP = ({
  email,
  type,
  setBack,
}: {
  email: string;
  type: any;
  setBack: React.Dispatch<React.SetStateAction<boolean>> | undefined;
}) => {
  const navigate = useNavigate();
  const {
    mutate,
    isSuccess: otpSuccess,
    isPending,
  } = useCheckPreviousRegistration();

  const handleSendOtp = () => {
    mutate({
      email: email,
      type: type,
    });
  };
  return (
    <div className='d-flex justify-content-between'>
      <Button
        onClick={() => setBack?.((prev) => !prev)}
        variant='success'
        className='d-flex align-items-center'
        style={{
          width: '80px',
          height: '40px',
          marginTop: '15px',
          //   textAlign: 'end',
        }}
      >
        <span className='me-'>Back</span>
      </Button>
      <Button
        onClick={handleSendOtp}
        variant='primary'
        className='d-flex align-items-center'
        style={{
          width: '100px',
          height: '40px',
          marginTop: '15px',
          textAlign: 'end',
        }}
      >
        <span className='me-2'>{isPending ? 'Loading' : 'Resend'} </span>
      </Button>
    </div>
  );
};

export default ResendOTP;
